import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Currency } from 'src/app/models/currency';
import { CurrenciesService } from 'src/app/api/currencies.service';
import { CryptoPriceData, PriceChartDuration } from 'src/app/models/price-chart';
import { CryptoPriceService } from 'src/app/services/crypto-price.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'crypto-detail',
  templateUrl: './crypto-page-detail.component.html',
  styleUrls: ['./crypto-page-detail.component.scss'],
  providers: [CryptoPriceService]
})
export class CryptoPageDetailComponent implements OnInit {
  PriceChartDuration = PriceChartDuration;
  chartColor: string;
  pair: string;
  mainCurrency: string;
  baseCurrency: string;
  currency: Currency;
  currencies: Currency[];
  duration = PriceChartDuration.SevenDays;

  loading = false;
  error: string = null;

  data: CryptoPriceData;

  useGlobalCurrency = !!environment.currencies.globalCurrency;

  constructor(
    private route: ActivatedRoute,
    private currenciesService: CurrenciesService,
    private cryptoPriceService: CryptoPriceService
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.pair = params.get('pair');
      if (!this.pair) {
        this.error = 'No Crypto Code provided';
      } else {
        const currencies = this.pair.split('-');
        this.mainCurrency = currencies[0];
        this.baseCurrency = currencies[1];

        this.cryptoPriceService.setBaseCurrency(this.baseCurrency);

        this.cryptoPriceService.valueChanges.subscribe(val => {
          this.data = val;
        });

        this.getCurrency();
      }
    });
  }

  getCurrency() {
    this.loading = true;
    this.error = null;
    this.currenciesService.getCryptoWithSupportedBase(this.baseCurrency).subscribe((response) => {
      this.loading = false;
      this.currency = response.find(item => item.code === this.mainCurrency);

      this.currencies = response.filter(
        (item) => item.code !== this.mainCurrency
      );

      if (!this.currency) {
        this.error = 'No Crypto provided';
      } else {
        this.cryptoPriceService.setCurrency(this.mainCurrency);
        this.cryptoPriceService.setDuration(this.duration);
      }
    }, err => {
      this.loading = false;
      this.error = 'No Crypto provided';
    });
  }

  changeDuration(duration: PriceChartDuration) {
    if (duration === this.duration) {
      return;
    }

    this.duration = duration;
    this.cryptoPriceService.setDuration(this.duration);
  }
}
